import { render, staticRenderFns } from "./CopyWorkflowEmailTemplateDialog.vue?vue&type=template&id=31d15de4"
import script from "./CopyWorkflowEmailTemplateDialog.vue?vue&type=script&lang=js"
export * from "./CopyWorkflowEmailTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports